export const FULFILMENT_TYPE = {
  CORE_PRIMARY: "CORE_PRIMARY",
  CORE_NON_PRIMARY: "CORE_NON_PRIMARY",
  AFS: "AFS",
  PARTNER_FULFILS: "PARTNER_FULFILS"
};

const getFulfilmentType = ({ sellerId, sourceId }) => {
  if (!sellerId && !sourceId) {
    return FULFILMENT_TYPE.CORE_PRIMARY;
  }

  if (!sellerId) {
    return FULFILMENT_TYPE.CORE_NON_PRIMARY;
  }

  if (sellerId !== sourceId) {
    return FULFILMENT_TYPE.AFS;
  }

  return FULFILMENT_TYPE.PARTNER_FULFILS;
};

export default getFulfilmentType;
